export enum ApiEndpointEnum {
  GetCart = '/actions/commerce/cart/get-cart',
  UpdateCart = '/actions/commerce/cart/update-cart',
  RemoveLineItem = '/actions/commerce/cart/remove-line-item',
  SessionInfo = '/api/users/session',
  GraphQLPublicSchema = '/actions/graphql/api',
  CommerceCountries = '/api/commerce/countries',
  CommerceAddressBase = '/api/commerce/addresses',
  UserGeo = '/api/user/geo'
}
